import { IconProps } from "./Icons";

export const IconChange = ({ width = 20, height = 20 }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6.234 7.79h-3.75V4.04"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.86 5.14a6.867 6.867 0 0 0-9.72 0L2.484 7.79M13.766 12.21h3.75v3.75"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5.14 14.86a6.869 6.869 0 0 0 9.72 0l2.655-2.65"
    />
  </svg>
);
